const handleFooterMobile = () => {
  $('.footer__col > h5').on('click', function() {
    const $this = $(this);
    const mobileBreakpoint = 767;
    const isMobileBreakpoint = $(window).innerWidth() <= mobileBreakpoint;

    if (! isMobileBreakpoint) {
      return;
    }

    $this.closest('.footer__col')
      .toggleClass('is-open')
      .find('.footer__nav')
      .slideToggle();
  });
}

handleFooterMobile();
